import { string } from 'prop-types';
import React from 'react';

function AudioSettings({ fill, ...props }) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_14575_234793)">
        <path
          d="M13.7628 6.00401C13.5604 5.90228 13.3339 5.85925 13.1086 5.87973C12.8833 5.90021 12.6681 5.9834 12.4872 6.11998L7.12821 9.54998H4.69231C4.36929 9.54998 4.0595 9.67904 3.83109 9.90877C3.60268 10.1385 3.47437 10.4501 3.47437 10.775V13.225C3.47437 13.5499 3.60268 13.8614 3.83109 14.0912C4.0595 14.3209 4.36929 14.45 4.69231 14.45H7.12821L12.4872 17.88C12.6681 18.0165 12.8833 18.0996 13.1086 18.12C13.3339 18.1405 13.5603 18.0974 13.7626 17.9956C13.9649 17.8939 14.1351 17.7375 14.254 17.544C14.3729 17.3505 14.4359 17.1275 14.4359 16.9V7.09998C14.436 6.87244 14.373 6.64939 14.2541 6.45581C14.1353 6.26224 13.9651 6.10579 13.7628 6.00401Z"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M19.6836 15.0625C20.233 14.1965 20.5248 13.1906 20.5248 12.1633C20.5248 11.1361 20.233 10.1302 19.6836 9.26416"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M17.3281 13.9935C17.7388 13.4851 17.963 12.8499 17.963 12.1948C17.963 11.5397 17.7388 10.9046 17.3281 10.3961"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M7.12817 9.55005V14.45"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
      </g>
      <defs>
        <clipPath id="clip0_14575_234793">
          <rect fill="white" height="14" transform="translate(2 5)" width="20" />
        </clipPath>
      </defs>
    </svg>
  );
}

AudioSettings.propTypes = {
  fill: string.isRequired
};

export default AudioSettings;
